<router-outlet></router-outlet>
<p-confirmDialog key="sal" header="Attenzione" icon="fas fa-ban" [rejectVisible]="false" acceptLabel="OK"></p-confirmDialog>

